export default __webpack_public_path__ + "static/images/burger_menu.b53d0fe5.png";